import { BarsOutlined, BookOutlined, CoffeeOutlined } from "@ant-design/icons";
import {Input, Layout, Menu} from "antd";
import {Link, Route, Routes, useNavigate} from "react-router-dom";
import Sider from "antd/lib/layout/Sider";
import About from "./about/container/About";
import Blog from "./blog/nickname/blog/container/Blog";
import Write from "./blog/write/container/Write";
import Login from "./blog/auth/container/Login";
import SignupVerify from "./blog/auth/container/SignupVerify";
import Post from "./blog/nickname/post/container/Post";
import Signup from "./blog/auth/container/Signup";

import React, {useEffect, useMemo, useRef, useState} from "react";
import { useLocation } from "react-router-dom";
import {actions as authActions} from "./blog/auth/state";
import {useDispatch, useSelector} from "react-redux";

import "antd/dist/antd.min.css";
import "./common/scss/common.scss";
import NotFound from "./common/container/NotFound";
import Series from "./blog/nickname/series/container/Series";
import Like from "./blog/nickname/like/container/Like";
import Temp from "./blog/nickname/temp/container/Temp";
import Setting from "./blog/setting/container/Setting";
import Dashboard from "./blog/dashboard/container/Dashboard";
import {AnimatePresence, motion} from "framer-motion";
import {actions as commonActions} from "./common/state";
import {actions as searchActions, Types as commonTypes} from "./blog/nickname/search/state";
import {BLOG, BOOKLOG, BOOKSENSE_URL, FetchType, HOME} from "./common/constant";
import CustomLayout from "./common/components/CustomLayout";
import Search from "./blog/nickname/search/container/Search";
import {makeUrlWithParams} from "./common/util/util";

export default function App() {
  const dispatch = useDispatch();
  const [siderCollapsed, setSiderCollapsed] = useState(true);
  const searchFlag = useSelector(state => state.common.searchFlag);
  const searchRef = useRef(null);
  const buttonRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();

  const location = useLocation();
  const pathname = location.pathname;

  // @ 포함 여부 확인
  const hasNickname = pathname.includes('@');

  // 닉네임만 추출 (공백 제거 등 추가 처리 가능)
  const nickname = hasNickname ? pathname.split('@')[1].split('/')[0] : null;

  /**
   * 검색 Input Blur 핸들링
   */
  const onInputBlur = () => {
    dispatch(commonActions.setValue({key: "searchFlag", value: false}));
    setSearchText('');
  }

  /**
   * 입력받은 검색어로 게시글 검색 ( 제목,소개,본문에서 검색함 )
   */
  const handleOnClick = () => {
    // 검색어가 있을 경우만 검색
    if (searchText) {
      window.scrollTo(0, 0);
      dispatch(searchActions.setValue({key: "post", value: []}));
      // 검색 결과를 위해 기존 post 목록을 비움
      dispatch(commonActions.setFetchStatus({
        actionType: commonTypes.FetchSearchPost,
        fetchType: FetchType.Delete,
      }))
      // 게시글 검색
      dispatch(
          searchActions.fetchSearchPost({ nickname: nickname, search: searchText })
      );
      if(pathname !== "/search") {
        navigate(makeUrlWithParams('/search', {nickname: nickname}));
      }
      // 현재 화면이 blog일 경우 처리
      dispatch(commonActions.setValue({ key: "searchFlag", value: false }));
      setSearchText('');
      // 검색버튼의 포커싱을 제거한다.
    }
  };

  /**
   * @description 엔터 이벤트 핸들링
   * @param {*} e
   */
  const handleOnKeyPress = (e) => {
    if (e.key === "Enter") {
      handleOnClick(); // Enter 입력이 되면 클릭 이벤트 실행
    }
  };

  function setScreenSize() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
  useEffect(() => {
    setScreenSize();
  });
  const items = useMemo(
      () => [
        {
          key: BLOG,
          icon: <BarsOutlined />,
          label: <Link to={`${BLOG}`}>ColdBrewCode</Link>,
        },
        {
          key: BOOKLOG,
          icon: <BookOutlined />,
          label: <a href={BOOKSENSE_URL}>BookSense</a>,
        },
      ],
      []
  );

  useEffect(() => {
    dispatch(authActions.fetchUser());
  }, [dispatch]);

  useEffect(() => {
    const bodyEl = document.getElementsByTagName("body")[0];
    const loadingEl = document.getElementById("init-loading");
    bodyEl.removeChild(loadingEl);
  }, []);

  return (
    <>
      <Layout
        style={{ height: "100vh", minHeight: "600px" }}
        className="ant-layout-has-sider"
      >
        <div
          style={{
            position: "fixed",
            top: 10,
            left: siderCollapsed ? 5 : 205,
            zIndex: 10,
            transition: "left 0.2s",
          }}
        >
          <BarsOutlined
            style={{ fontSize: 22, cursor: "pointer", padding: 6 }}
            onClick={() => setSiderCollapsed(!siderCollapsed)}
          />
        </div>
        <Sider
          className="fix-menu"
          theme="light"
          width={200}
          style={{ paddingTop: 60, zIndex: 2, height: "100%" }}
          collapsed={siderCollapsed}
          collapsedWidth="0"
          trigger={null}
        >
          <div className="logo" />
          <Menu
              selectedKeys={[location.pathname]}
              mode="inline"
              theme="light"
              style={{ height: "100%" }}
              items={items}
          />
        </Sider>
        <AnimatePresence>
          {searchFlag && (
              <>
                <motion.div
                    key="modal"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0, transition: { duration: 0.3 } }}
                    className="overlay"
                >
                </motion.div>
                <div className="searchBar open">
                  <Input
                      ref={searchRef}
                      id="searchQueryInput"
                      type="text"
                      name="searchQueryInput"
                      placeholder="검색어를 입력하세요"
                      value={searchText}
                      autoFocus
                      onChange={(search) => setSearchText(search.target.value)}
                      onPressEnter={handleOnKeyPress}
                      onBlur={onInputBlur}
                  />
                  <button
                      ref={buttonRef}
                      id="searchQuerySubmit"
                      type="submit"
                      name="searchQuerySubmit"
                      onClick={handleOnClick}
                  >
                    <svg style={{ width: 24, height: 24, position: 'relative'}} viewBox="0 0 24 24"><path fill="#666666" d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
                    </svg>
                  </button>
                </div>
              </>
          )}
        </AnimatePresence>
        <Layout
          className="site-layout-background"
          style={{ minWidth: 375, width: "100%" }}
        >
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/signup/verify" element={<SignupVerify />} />
            <>
              <Route path="/" element={<CustomLayout classNames={'dashboard-content'}/>}>
                <Route index element={<Dashboard/>}/>
                <Route path="/search" element={<Search/>}/>
                <Route path="/login" element={<Login/>}/>
                <Route path="/signup" element={<Signup/>}/>
                <Route path="/write" element={<Write/>}/>
                <Route path="/write/:id" element={<Write/>}/>
              </Route>
            </>
            <Route path="/" element={<CustomLayout classNames={'main-content setting-wrap'}/>}>
              <Route path="/user/setting" element={<Setting />} />
            </Route>

            <Route path="/@:nickname" element={<CustomLayout classNames={'main-content'}/>}>
              <Route index element={<Blog />} />
            </Route>

            <Route path="/@:nickname" element={<CustomLayout classNames={'main-content post-wrap'}/>}>
              <Route path="/@:nickname/post/:id" element={<Post />} />
              <Route path="/@:nickname/series/:id" element={<Series />} />
              <Route path="/@:nickname/like/post" element={<Like />} />
              <Route path="/@:nickname/temp/post" element={<Temp />} />
            </Route>

            <Route path="*" element={<NotFound />} />

          </Routes>
        </Layout>
      </Layout>
    </>
  );
}
